import { useState } from "react";
import { Star, ChevronLeft, ChevronRight } from "lucide-react";
import { Reveal, MaskLinesInView } from "./motion";

const REVIEWS = [
  {
    quote:
      "Éramos quinze pessoas e a casa acolheu-nos a todos com folga. Espaços amplos, cozinha maravilhosa para longas refeições em família — voltamos de certeza.",
    author: "Beatriz Almeida",
    context: "Reunião de família · Julho",
  },
  {
    quote:
      "A sensação de acordar no meio da floresta é impagável. Estivemos uma semana e não quisemos sair da propriedade. A cozinha tem tudo o que se possa desejar.",
    author: "Rui Marques",
    context: "Férias com amigos · Agosto",
  },
  {
    quote:
      "Pela sofisticação, discrição e privacidade que oferece, é sem dúvida um dos melhores alojamentos que já experimentámos em Portugal. A sala com lareira ficou-nos no coração.",
    author: "Sofia & Pedro Vasconcelos",
    context: "Aniversário · Setembro",
  },
  {
    quote:
      "Local perfeito para grupos grandes. Muito bem localizado — perto do Porto, mas com aquela paz de quem está longe de tudo. Recomendamos vivamente.",
    author: "João Ferreira",
    context: "Retiro de equipa · Outubro",
  },
];

export default function Testimonials() {
  const [i, setI] = useState(0);
  const next = () => setI((v) => (v + 1) % REVIEWS.length);
  const prev = () => setI((v) => (v - 1 + REVIEWS.length) % REVIEWS.length);
  const r = REVIEWS[i];

  return (
    <section
      id="testemunhos"
      data-testid="testimonials-section"
      className="relative py-28 lg:py-40 bg-forest text-cream overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.06] pointer-events-none">
        <div className="absolute -top-40 -left-40 w-[600px] h-[600px] rounded-full bg-cream blur-3xl" />
        <div className="absolute -bottom-40 -right-40 w-[600px] h-[600px] rounded-full bg-terracotta blur-3xl" />
      </div>

      <div className="relative mx-auto max-w-[1400px] px-6 lg:px-12">
        <Reveal>
          <div className="flex items-center gap-4 mb-8">
            <span className="h-px w-14 bg-cream/40" />
            <p className="overline text-cream/70">Testemunhos</p>
          </div>
        </Reveal>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-[4rem] leading-[1.05] tracking-tight font-light max-w-3xl">
          <MaskLinesInView lines={["Palavras de quem", <span key="i" className="italic">já cá esteve.</span>]} />
        </h2>

        <div className="mt-16 lg:mt-20 grid lg:grid-cols-12 gap-10 lg:gap-16 items-end">
          <div className="lg:col-span-9">
            <div
              key={i}
              data-testid="testimonial-active"
              className="reveal"
            >
              <div className="flex gap-1 mb-8">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star
                    key={s}
                    size={18}
                    strokeWidth={1}
                    className="fill-cream text-cream"
                  />
                ))}
              </div>
              <p className="font-display text-3xl sm:text-4xl lg:text-[3.4rem] leading-[1.15] font-light">
                &ldquo;{r.quote}&rdquo;
              </p>
              <div className="mt-10 flex items-center gap-4">
                <span className="h-px w-12 bg-cream/50" />
                <div>
                  <div className="font-medium text-cream">{r.author}</div>
                  <div className="text-cream/60 text-sm mt-0.5">{r.context}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-3 flex lg:flex-col items-center lg:items-end gap-6">
            <div className="flex items-center gap-3">
              <button
                data-testid="testimonial-prev"
                onClick={prev}
                className="w-12 h-12 rounded-full border border-cream/40 flex items-center justify-center hover:bg-cream/10 transition-colors"
                aria-label="Anterior"
              >
                <ChevronLeft size={18} strokeWidth={1.5} />
              </button>
              <button
                data-testid="testimonial-next"
                onClick={next}
                className="w-12 h-12 rounded-full border border-cream/40 flex items-center justify-center hover:bg-cream/10 transition-colors"
                aria-label="Seguinte"
              >
                <ChevronRight size={18} strokeWidth={1.5} />
              </button>
            </div>
            <div className="font-display text-cream/60 text-lg tracking-wider">
              <span className="text-cream text-2xl">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="mx-2">/</span>
              {String(REVIEWS.length).padStart(2, "0")}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
